import { render } from "./VistaDetallePedidoInstalacion_origen_productos.vue?vue&type=template&id=08d867bf"
import script from "./VistaDetallePedidoInstalacion_origen_productos.vue?vue&type=script&lang=js"
export * from "./VistaDetallePedidoInstalacion_origen_productos.vue?vue&type=script&lang=js"

import "./VistaDetallePedidoInstalacion_origen_productos.vue?vue&type=style&index=0&id=08d867bf&lang=css"

import exportComponent from "D:\\Users\\felipecedillo\\Documents\\GitHub\\marbel-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__